const refundData = {
    title: "Refund Policy",
    updatedDate: "April 1, 2025",
    introduction: [
        "MINDSCLIK through its platform MPERITO provides ability for its customers to launch their branded ecommerce application on web and mobile. As part of the solution few of its customers (businesses) can leverage MINDSCLIK payment gateway to collect money on the purchases made end customer.",
        "The following Refund Policy is applicable to the Customers or Businesses that are leveraging the MPERITO platform along with its payment gateway:"
    ],
    sections: [
        {
            title: "Refund Eligibility",
            subtitle: "",
            content: [
                { type: "text",
                  items: ["Refunds may be issued in the following circumstances:"],
                },
                {
                    type: "bullet",
                    items: [
                        "The customer cancels an order before it has been shipped.",
                        "The customer returns a product in accordance with our return policy.",
                        "A refund is required due to a mistake on our part (e.g., billing errors, defective products).",
                    ]
                },
            ]
        },
        {
            title: "Refund Process",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Customers must contact our customer support team to request a refund.",
                        "Refunds will be processed back to the original payment method within 15 business days of the refund request being approved."
                    ]
                },

            ]
        },
        {
            title: "Refund Exceptions",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "We reserve the right to refuse refunds in cases where products are returned in a used or damaged condition, or if the return does not meet our return policy criteria." 
                    ]
                },

            ]
        },
        {
            title: "Changes to this Refund Policy",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "We may update Our Refund Policy from time to time. We will notify You of any changes by posting the new Refund Policy on this page.",
                        'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Refund Policy.',
                        "You are advised to review this Refund Policy periodically for any changes. Changes to this Refund Policy are effective when they are posted on this page."
                    ]
                },
            ]
        },
        {
            title: "Contact Us",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "If you have any questions about this Refund Policy, You can contact us:",
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "By email: support@mindsclik.com",
                    ]
                },

            ]
        },
    ]
};

export default refundData;

// type = { title | text | bullet | numbered }